import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

export default class Header extends Component {
	render() {
		return (
			<header class={style.header}>
				<nav>
					<Link activeClassName={style.active} href="/">罗博深首页</Link>
					<Link activeClassName={style.active} href="/about">谁是罗博深?</Link>
					<Link activeClassName={style.active} href="/#activities">罗博深在中国</Link>
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js